import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CONTRACTOR_CLIENTS_CRUD_ACTION_CONSTANTS =
	crudActionConstantsGenerator('CONTRACTOR_CLIENTS');
export const CONTRACTOR_CLIENTS_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CONTRACTOR_CLIENTS_CRUD_ACTION_CONSTANTS
);
